import styled, { css } from 'styled-components';

export const FilterPopupContainerStyled = styled.div``;

export const FilterPopupDropdownStyles = css`
  padding: 0;
  min-width: 350px;
`;
